import { config as globalConfig } from "../../../config";

const config = {
  productCard: {
    tooltip: "POLICY.RECOMMENDED",
    total: "POLICY.TOTAL",
    isRecommended: "Al Shamel",
  },
  steps: [
    {
      label: "STEPPER.COMPANYDETAILS",
      description: "",
    },
    {
      label: "STEPPER.VEHICLEDETAILS",
      description: "",
    },
    {
      label: "STEPPER.POLICYCOVERAGE",
      description: "",
    },
    {
      label: "STEPPER.PAYMENT",
      description: "",
    },
  ],
  carousel: [
    {
      title: "CAROUSEL.HEADING",
      description: "",
    },
    {
      title: "CAROUSEL.HEADING",
      description: "",
    },
    {
      title: "CAROUSEL.HEADING",
      description: "",
    },
    {
      title: "CAROUSEL.HEADING",
      description: "",
    },
    {
      title: "CAROUSEL.HEADING",
      description: "",
    },
  ],
  motorSteps: [
    {
      stepIndex: 0,
      path: "/Home",
      next: true,
      prev: false,
      pay: false,
    },
    {
      stepIndex: 1,
      path: "/vehicle-detail",
      next: true,
      prev: true,
      pay: false,
    },
    {
      stepIndex: 2,
      path: "/policy-detail",
      next: true,
      prev: true,
      pay: false,
    },
    {
      stepIndex: 3,
      path: "/payment",
      next: false,
      prev: true,
      pay: true,
    },
    {
      stepIndex: 4,
      path: "/success",
      next: false,
      prev: true,
      pay: true,
    },
  ],
  sadadSuccessRedirect: `/kit/sadad`,
  paymentFailedRedirect: `${globalConfig.redirectDomainUrl}/motor/failed`,
  paymentSuccessRedirect: `${globalConfig.redirectDomainUrl}/welcome-kit`,
  paymentSuccessKitCredit: `${globalConfig.redirectDomainUrl}/motor/kit/credit`,
  paymentSuccessKitSadad: `${globalConfig.redirectDomainUrl}/motor/kit/sadad`,

  sadadSuccessRedirect: "/kit/sadad",

  //OLD WelcomKit
  paymentSuccessRedirect: `${globalConfig.redirectDomainUrl}/welcome-kit`,


  //OLD WelcomKit
  paymentSuccessRedirect: `${globalConfig.redirectDomainUrl}/welcome-kit`,


  deductable: [
    { label: String(500), value: String(500) },
    { label: String(750), value: String(750) },
    { label: String(1000), value: String(1000) },
    { label: String(1500), value: String(1500) },
    { label: String(2000), value: String(2000) },
    { label: String(2500), value: String(2500) },
    { label: String(3500), value: String(3500) },
    { label: String(5000), value: String(5000) },
    { label: String(10000), value: String(10000) },
  ],

  deductible: [
    { label: String(500), value: String(500) },
    { label: String(750), value: String(750) },
    { label: String(1000), value: String(1000) },
    { label: String(1500), value: String(1500) },
    { label: String(2000), value: String(2000) },
    { label: String(2500), value: String(2500) },
    { label: String(3500), value: String(3500) },
    { label: String(5000), value: String(5000) },
    { label: String(10000), value: String(10000) },
  ],
  productCode: {
    tp: "MotorImtiazeTP",
    sp: "PRMotorImtiazeSP",
    co: "PRMotorImtiazeCO",
  },

  LicenseType: [{ "licenseTypeCode": "3", "licenseTypeDescription": "MOTORCYCLE" }, { "licenseTypeCode": "7", "licenseTypeDescription": "LIGHT TRANSPORT" }, { "licenseTypeCode": "11", "licenseTypeDescription": "LARGE BUS" }, { "licenseTypeCode": "1", "licenseTypeDescription": "Private" }, { "licenseTypeCode": "2", "licenseTypeDescription": "PUBLIC" }, { "licenseTypeCode": "4", "licenseTypeDescription": "TEMPORARY LICENSE (PERMISSION)" }, { "licenseTypeCode": "5", "licenseTypeDescription": "PUBLIC TAXI" }, { "licenseTypeCode": "6", "licenseTypeDescription": "PICKUP / PASSING CARS" }, { "licenseTypeCode": "8", "licenseTypeDescription": "HEAVY TRANSPORT" }, { "licenseTypeCode": "9", "licenseTypeDescription": "PUBLIC WORKS VEHICLES" }, { "licenseTypeCode": "10", "licenseTypeDescription": "SMALL BUS" }],
  LicenseTypeAr: [
    {
      "licenseTypeCode": "3",
      "licenseTypeDescription": "دراجة ألية"
    },
    {
      "licenseTypeCode": "7",
      "licenseTypeDescription": "نقل خفيف"
    },
    {
      "licenseTypeCode": "11",
      "licenseTypeDescription": "باص كبير"
    },
    {
      "licenseTypeCode": "1",
      "licenseTypeDescription": "خاص"
    },
    {
      "licenseTypeCode": "2",
      "licenseTypeDescription": "عمومي خاصة"
    },
    {
      "licenseTypeCode": "4",
      "licenseTypeDescription": "رخصة مؤقتة (تصريح)"
    },
    {
      "licenseTypeCode": "5",
      "licenseTypeDescription": "اجرة عامة"
    },
    {
      "licenseTypeCode": "6",
      "licenseTypeDescription": "نقل صغير / سيارات عابرة"
    },
    {
      "licenseTypeCode": "8",
      "licenseTypeDescription": "نقل ثقيل"
    },
    {
      "licenseTypeCode": "9",
      "licenseTypeDescription": "مركبات اشغال عامة"
    },
    {
      "licenseTypeCode": "10",
      "licenseTypeDescription": "حافلة صغيرة"
    }
  ],
  MileagePerYearAR: [
    {
      "mileagePerYearDescription": "أقل من 10000",
      "mileagePerYearCode": "1"
    },
    {
      "mileagePerYearDescription": "ما بين 10000 و 25000",
      "mileagePerYearCode": "2"
    },
    {
      "mileagePerYearDescription": "ما بين 25000 و 50000",
      "mileagePerYearCode": "3"
    },
    {
      "mileagePerYearDescription": "مابين 50000 و 100000",
      "mileagePerYearCode": "4"
    },
    {
      "mileagePerYearDescription": "ما بين 100000 و 300000",
      "mileagePerYearCode": "5"
    },
    {
      "mileagePerYearDescription": "أعلى من 300000",
      "mileagePerYearCode": "6"
    }
  ],
  MileagePerYear: [
    {
      "mileagePerYearDescription": "Less than 10000.",
      "mileagePerYearCode": "1"
    },
    {
      "mileagePerYearDescription": "Between 10000 and 25000.",
      "mileagePerYearCode": "2"
    },
    {
      "mileagePerYearDescription": "Between 25000 and 50000.",
      "mileagePerYearCode": "3"
    },
    {
      "mileagePerYearDescription": "Between 50000 and 100000.",
      "mileagePerYearCode": "4"
    },
    {
      "mileagePerYearDescription": "Between 100000 and 300000.",
      "mileagePerYearCode": "5"
    },
    {
      "mileagePerYearDescription": "Above 300000.",
      "mileagePerYearCode": "6"
    }
  ],
  ParkingLocations: [
    {
      "locationDescription": "Parking Lot",
      "locationCode": "MOTOR_AR_PARKING"
    },
    {
      "locationDescription": "Own Garage",
      "locationCode": "MOTOR_AR_OWNGARAG"
    },
    {
      "locationDescription": "On the Road",
      "locationCode": "MOTOR_AR_ONROAD"
    }
  ],
  ParkingLocationsAr: [
    {
      "locationDescription": "موقف للسيارات",
      "locationCode": "MOTOR_AR_PARKING"
    },
    {
      "locationDescription": "موقف خاص",
      "locationCode": "MOTOR_AR_OWNGARAG"
    },
    {
      "locationDescription": "على الطريق",
      "locationCode": "MOTOR_AR_ONROAD"
    }
  ],








  mechanicalFeatures: [
    {
      label: "engine",
      price: "20,000",
      codes: ["MC_GD", "MC_SI", "MC_ST"],
    },
    {
      label: "gearbox",
      price: "10,000",
      codes: ["MC_GD", "MC_SI", "MC_ST"],
    },
    {
      label: "differential",
      price: "10,000",
      codes: ["MC_GD", "MC_SI", "MC_ST"],
    },
    {
      label: "turbo-assembly",
      price: "5,000",
      codes: ["MC_GD", "MC_SI"],
    },
    {
      label: "management-system",
      price: "5,000",
      codes: ["MC_GD", "MC_SI"],
    },

    {
      label: "prop-shaft-CV-joints",
      price: "4,000",
      codes: ["MC_GD", "MC_SI"],
    },

    {
      label: "steering-mechanism",
      price: "4,000",
      codes: ["MC_GD", "MC_SI"],
    },
    {
      label: "wheel-bearings",
      price: "4,000",
      codes: ["MC_GD", "MC_SI"],
    },
    {
      label: "braking-system",
      price: "4,000",
      codes: ["MC_GD", "MC_SI"],
    },
    {
      label: "fuel-system",
      price: "4,000",
      codes: ["MC_GD", "MC_SI"],
    },
    {
      label: "electrical-components",
      price: "4,000",
      codes: ["MC_GD", "MC_SI"],
    },
    {
      label: "electrical-ignition",
      price: "4,000",
      codes: ["MC_GD", "MC_SI"],
    },
    {
      label: "suspension",
      price: "4,000",
      codes: ["MC_GD", "MC_SI"],
    },
    {
      label: "cylinder-head-gasket",
      price: "4,000",
      codes: ["MC_GD"],
    },
    {
      label: "radiator",
      price: "4,000",
      codes: ["MC_GD"],
    },

    {
      label: "air-conditioner",
      price: "4,000",
      codes: ["MC_GD"],
    },
    {
      label: "overheating",
      price: "4,000",
      codes: ["MC_GD"],
    },
    {
      label: "cambelt-failure",
      price: "4,000",
      codes: ["MC_GD"],
    },
    {
      label: "clutch",
      price: "4,000",
      codes: ["MC_GD"],
    },
    {
      label: "electric-fans-sunroof",
      price: "4,000",
      codes: ["MC_GD"],
    },
  ],
};
export default config;
